import React from 'react'

export const flattenJsonErrors = function(data) {

    let result = {};

    /**
     * @param {{}} current
     * @param {string} prop
     */
    function recurse(current, prop) {
        if (Object(current) !== current) {
            result[prop] = current;
        } else if (Array.isArray(current)) {
            let length = ''
            for (let i = 0, length = current.length; i < length; i++) {
                recurse(current[i], prop ? prop + "[" + i + "]" : "" + i)
            }
            if (length === 0) {
                result[prop] = []
            }
        } else {
            let isEmpty = true;
            for (let property in current) {
                isEmpty = false;
                recurse(current[property], prop ? prop + "." + property : property)
            }
            if (isEmpty) {
                result[prop] = {};
            }
        }
    }

    recurse(data, "");
    return result;
}

